module.exports = __webpack_public_path__ + "img/directoriesCount.779bce5f.png";